"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// potentially move to ui-components (Epic EN-2537)
const react_1 = __importDefault(require("react"));
const loading_component_1 = require("./loading.component");
exports.default = (loader) => (props) => {
    const LazyComponent = react_1.default.lazy(loader);
    return (react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement(loading_component_1.SimpleLoading, null) }, react_1.default.createElement(LazyComponent, Object.assign({}, props))));
};
